import { getUser } from '../../services/api/user.api';
import { GET_USER_SINGLE_REQUEST, GET_USER_SINGLE_SUCCESS, GET_USER_SINGLE_FAILURE } from '../types';
import { transformUser } from '../../transforms/users';
import { transformError } from '../../transforms/error';
import { dateFriendly } from '../../helpers/date';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: {},
	},

	getters: {
		createdAt: (state) => dateFriendly(state.data.created_at),
		updatedAt: (state) => dateFriendly(state.data.updated_at),
	},

	mutations: {
		[GET_USER_SINGLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_USER_SINGLE_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformUser(data);
		},
		[GET_USER_SINGLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getUser({ commit }, id) {
			try {
				commit(GET_USER_SINGLE_REQUEST);
				const { data } = await getUser(id);
				commit(GET_USER_SINGLE_SUCCESS, data);
			} catch (error) {
				commit(GET_USER_SINGLE_FAILURE, error);
			}
		},
	},
};